
import { routeConfigs } from "./RouteList";
import { Suspense, useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import { NotFound } from "pages";
import { LoadingScreen } from "components";

export default function Router() {

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const delay = setTimeout(() => {
      setIsReady(true);
    }, 2000); // ⏱️ 2 seconds delay

    return () => clearTimeout(delay);
  }, []);

  if (!isReady) {
    return <LoadingScreen />;
  }


  const createRoutes = (configs) => {
    return configs.map(config => ({
      element: <config.layout />,
      errorElement: <NotFound />,
      children: config.children.map(child => ({
        path: child.path,
        element: child.isPrivate
          ? <PrivateRoute element={<child.element />} />
          : <PublicRoute element={<child.element />} />,
        errorElement: <NotFound />,
      })),
    }));
  };

  const routes = createRoutes(routeConfigs);

  const router = createBrowserRouter(routes);
  return (
    <Suspense fallback={<LoadingScreen />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}